import type { ReactNode } from 'react'

export default function Body({ children = null }: { children?: ReactNode }) {
  return (
    <div className="bg-[var(--bg-color)] w-[100%] mx-auto min-h-[100vh]">
      {children}
    </div>
  )
}
